/* GASSISA
=========================================================================================
* Descripcion: Contenedor responsivo para formularios en dispositivos portatiles.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de envoltura portatil para formularios Frm
*      2       | 25/06/2026 | Lic. Jose Luis Aragon Cervantes  | Indicador visible PORTATIL para depuracion
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Clase raiz portatil autosuficiente para estilos
* ---------------------------------------------------------------------------------------
*/

import { Chip } from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

export default function SizeSoftXFrmPortatil({ children, nombreFormulario }) {
  return (
    <section className="sizesoftx-portatil portatil-frm" data-formulario={nombreFormulario}>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: "4px 8px" }}>
        <Chip
          icon={<PhoneAndroidIcon />}
          label="PORTÁTIL"
          color="warning"
          size="small"
          variant="outlined"
        />
      </div>
      {children}
    </section>
  );
}
